import { api, ACCOUNT_API_SUB_URLS, REFERENCE_API_SUB_URLS } from '@/api';
import { AxiosResponse } from 'axios';
import { Module } from 'vuex';
import {
  RootState,
  TaxYearsResponseModel,
  AccountStatementsResponseModel,
} from '@/@types/member';

interface StatementsState {
  accountStatements: AccountStatementsResponseModel;
  taxStatementYears: TaxYearsResponseModel;
}

const STATEMENTS_STATE: Module<StatementsState, RootState> = {
  state: {
    accountStatements: null,
    taxStatementYears: null,
  },
  actions: {
    // UC-REST-033
    getMemberAccountStatement(
      context,
      { accountId, payload },
    ): Promise<AxiosResponse> {
      return api
        .get(
          `${ACCOUNT_API_SUB_URLS.accounts}/${accountId}/statements-v2`,
          {
            params: payload,
          },
        )
        .then((memberAccountStatements) => {
          context.commit(
            'setMemberAccountStatements',
            memberAccountStatements.data,
          );
        });
    },
    // UC-REST-065
    getMemberTaxStatementYears(context): Promise<AxiosResponse> {
      return api
        .get(
          `${REFERENCE_API_SUB_URLS.references}/tax-years`,
        )
        .then((memberTaxStatementYears) => {
          context.commit(
            'setMemberTaxStatementYears',
            memberTaxStatementYears.data,
          );
        });
    },
  },
  mutations: {
    setMemberAccountStatements(
      state: StatementsState,
      data: AccountStatementsResponseModel,
    ) {
      state.accountStatements = data;
    },
    setMemberTaxStatementYears(
      state: StatementsState,
      data: TaxYearsResponseModel,
    ) {
      state.taxStatementYears = data;
    },
  },
  getters: {
    memberAccountStatements(state): AccountStatementsResponseModel {
      return state.accountStatements;
    },
    memberTaxStatementYears(state): TaxYearsResponseModel {
      return state.taxStatementYears;
    },
  },
};

export default STATEMENTS_STATE;
